import { useForm, Controller } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField, Checkbox } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { DischargeSummaryAddDiagnosForm } from '../../HMS/transactions/DischargeSummaryAddDiagnosForm';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { GENDER_DROPDOWN } from '../../../../../constants';
import { AddSurgeryDetailsForm } from './AddSurgeryDetailsForm';
import { AddResourcesDetailsForm } from './AddResourcesDetailsForm';

const OT_SCHEDULE_TABLE_HEADER = [
  {
    header: 'Schedule No',
    accessor: (row) => row?.schedule_no
  },
  {
    header: 'IPD No',
    accessor: 'ipd_no'
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Operation Theatre',
    accessor: (row) => row?.otDetails[0]?.operationtheatre
  }
];

const TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const ADD_SUREGRY = [
  {
    header: 'Region',
    accessor: 'regionName'
  },
  {
    header: 'Surgery Name',
    accessor: 'surgeryName'
  },
  {
    header: 'Major/Minor',
    accessor: 'surgery_type'
  },
  {
    header: 'Start Time',
    accessor: 'sch_time'
  },
  {
    header: 'End Time',
    accessor: 'end_time'
  }
];

const ADD_DIAGNOSIS = [
  {
    header: 'Diagnosis List',
    accessor: 'add_diagnos'
  },
  {
    header: 'Date',
    accessor: 'createdAt'
  }
];

const ADD_Resource = [
  {
    header: 'Resource Type',
    accessor: (row) => row.type
  },
  {
    header: 'Resource Name',
    accessor: (row)=> row?.doctorName || row?.equipmentName
  }
];

const OT_TEMPLATE_TABLE_HEADER = [
  {
    header: 'Heading',
    accessor: 'heading'
  },
  {
    header:"Status",
    accessor:"status"
  }
];

const initialOTEntryDataObj = {
  data: [],
  loading: false
};

const initialOtScheduleDataObj = {
  data: [],
  loading: false
};

export const OTEntry = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [oTEntryDataObj, setOTEntryDataObj] = useState(initialOTEntryDataObj);
  const [otScheduleDataObj, setOtScheduleDataObj] = useState(initialOtScheduleDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [medicineDetailList, setmedicineDetailList] = useState([]);
  const [addDiagnosDialogOpen, setAddDiagnosDialogOpen] = useState(false);
  const [diagnos, setDiagnos] = useState([]);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [inputOt, setInputOt] = useState('');
  const [openOtScheduleDialog, setOpenOtScheduleDialog] = useState(false);
  const [wardDropdown, setWardDropdown] = useState([]);
  const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
  const [operationtheatreDropdown, setOpearationtheatreDropdown] = useState([]);
  const [anaesthesiaDropdown, setAnaesthesiaDropdown] = useState([]);
  const [surgeryDetails, setSurgeryDetails] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);
  const [addSurgeryDialogOpen, setAddSurgeryDialogOpen] = useState(false);
  const [addResourcesDialogOpen, setAddResourcesDialogOpen] = useState(false);
  const [serviceDropdown, setServiceDropdown] = useState([]);
  const [regionDropdown, setRegionDropdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [editData, setEditData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalOTScheduleData, setOriginalOTScheduleData] = useState([]);
  const [dischargeSummaryTemplateList,setDischargeSummaryTemplateList] = useState([])
  const [selectedRows,setSelectedRows] = useState([])
  const [editorData, setEditorData] = useState('');
  const [equipmentDropdown,setEquipmentDropdown] = useState([])


  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }
    return age;
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' '),
        anaesthesia:Yup.string().required(' ')

      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue, getValues } = methods;

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  useEffect(() => {
    getDepartmentDropdown();
  }, getDepartmentDropdown);

  useEffect(() => {
    if (selectedRecord) {
      // Extract and set flat key-value pairs while excluding specific keys
      const keyValuePair = getKeyPathValue(selectedRecord, '', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'surgery_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => {
        setValue(key, value);
      });
      setValue('uhid', selectedRecord.uhid);
      setValue('patient_name',selectedRecord?.patient?.name)
      setValue('room', selectedRecord?.ipdpatient?.consultant_detail?.room);
      setValue('ward', selectedRecord?.roomDetails?.[0]?.ward);
      setValue('bed_no', selectedRecord?.ipdpatient?.consultant_detail?.bed_no);
      setValue('remarks', selectedRecord?.remarks);
      setValue('gender', selectedRecord?.patient?.gender);
      setValue('age', calculateAge(selectedRecord?.patient?.dob));
      setValue('mobile', selectedRecord?.patient?.mobile_no);
      const formattedRegDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedRegDate);
      setValue('time', getCurrentDateTime('time', selectedRecord.time || selectedRecord.createdAt));
      if (selectedRecord.surgery_items) {
        setSurgeryDetails(selectedRecord.surgery_items);
      }
      if (selectedRecord.diagnos_detail) {
        setDiagnos(selectedRecord.diagnos_detail);
      }
      if (selectedRecord.resource_detail) {
        setResourceDetails(selectedRecord.resource_detail);
      }
      if (selectedRecord.editorContent) {
        setEditorData(selectedRecord.editorContent);
      }
    } else {
      reset();
      setSurgeryDetails([]);
      setDiagnos([]);
      setResourceDetails([]);
      setEditorData('');
    }
  }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/ot-entry-edit' : '/ot-entry-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        surgery_items: surgeryDetails,
        diagnos_detail: diagnos,
        resource_detail: resourceDetails,
        editorContent: editorData
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} OT Entry`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} OT Entry`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };


  const handleRowDelete = (rowId) => {
    setDiagnos((prev) =>
      prev.filter((data) => {
        return data.add_diagnos !== rowId;
      })
    );
  };

  const handleSuregryDelete = (row) => {
    setSurgeryDetails((prev) => prev.filter((data) => data.surgery !== row));
  };

  const handleRowResourceDelete = (rowId) => {
    setResourceDetails((prev) =>
      prev.filter((data) => {
        return data.doctor != rowId;
      })
    );
  };

  const onDetailAddHandler = (data) => {
    const surgeryName = serviceDropdown.find(({ _id }) => _id === data.surgery)?.service_name;
    const regionName = regionDropdown.find(({ _id }) => _id === data.region)?.region;

    if (isEditMode && editData?._id) {
      // Edit Mode: Update the existing row with the same `_id`
      setSurgeryDetails((prev) =>
        prev.map((detail) =>
          detail.surgery === editData.surgery
            ? {
                ...detail,
                ...data,
                surgeryName: surgeryName,
                regionName: regionName
              }
            : detail
        )
      );
    } else {
      // Add Mode: Check for duplicates and add new entry
      const existingDetail = surgeryDetails.find(({ surgery }) => surgery === data.surgery);
      if (existingDetail) {
        toast('Surgery already chosen', { variant: 'error' });
        return;
      }

      setSurgeryDetails((prev) => [
        ...prev,
        {
          ...data,
          surgeryName: surgeryName,
          regionName: regionName
        }
      ]);
    }
  };
console.log(surgeryDetails,"SUREGRY DETAILS IS HERE")
  const onAddAddResourcehandler = (data) => {
    const existingDetail = resourceDetails.find(({ doctor }) => doctor === data.doctor);
    
    if (existingDetail) {
      toast('Doctor already chosen', { variant: 'error' });
      return;
    } else {
      toast('Resources Added Successfully', { variant: 'success' });
    }
    const doctorName = doctorDropdown.find(({ _id }) => _id === data.doctor)?.name;
    const equipmentName = equipmentDropdown.find(({ _id }) => _id === data?.equipment)?.equipment;
    // Check if the doctor or equipment is present and remove the other key accordingly
    let resourceData = {
      ...data,
      doctorName: doctorName,
      equipmentName: equipmentName,
    };
    if (data.doctor && data.equipment) {
      // If both doctor and equipment are present, remove the other key
      delete resourceData.equipment;
    } else if (data.equipment) {
      // If only equipment is provided, remove the doctor key
      delete resourceData.doctor;
      delete resourceData.doctorName; // Remove doctorName if doctor is removed
    } else if (data.doctor) {
      // If only doctor is provided, remove the equipment key
      delete resourceData.equipment;
      delete resourceData.equipmentName; // Remove equipmentName if equipment is removed
    }
    // Update the resource detail list
    setResourceDetails((prev) => [
      ...prev,
      resourceData,
    ]);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/opd-requisition-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted OPD Requisition', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete OPD Requisition', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/opd-requisition-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel OPD Requisition', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel OPD Requisition', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setOTEntryDataObj({ loading: true });
    const response = await request('/ot-entry-list', { method: 'GET',query:{limit:10}});
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOTEntryDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOTEntryDataObj({ loading: false });
    }
  };


  useEffect(() => {
    handleOtEntrySearch(input);
  }, [input]);

  const handleOtEntrySearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
      try {
        const response = await request('/ot-entry-list', {
          method: 'GET',
          query: { name: lowercasedInput ,limit:10}
        });
        if (response.success && Array.isArray(response.data)) {
          setOTEntryDataObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setOTEntryDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setOTEntryDataObj({ loading: false, data: [] });
      }
  
  };

  const handleOtChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };



  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  const getWardDropdown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  }, []);

  const getRoomMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('room-master');
    setRoomMasterDropdown(data);
  }, []);

  const getOpeartionTheatreDropdown = useCallback(async () => {
    const data = await dropdownFetch('operation-theatre');
    setOpearationtheatreDropdown(data);
  }, []);

  const getAnaesthesiaDropdown = useCallback(async () => {
    const data = await dropdownFetch('anaesthesia-master');
    setAnaesthesiaDropdown(data);
  }, []);

  const getServiceDropdown = useCallback(async () => {
    const data = await dropdownFetch('service');
    const filterData = data.filter((item) => item.type === 'SR');
    setServiceDropdown(filterData);
  }, []);

  const getRegionDropdown = useCallback(async () => {
    const data = await dropdownFetch('region-master');
    setRegionDropdown(data);
  }, []);

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor-surgeon');
    if (!selectedRecord && !getValues('doctor')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }
    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getEquipmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('equipment-master');
    setEquipmentDropdown(data);
  }, []);


  useEffect(() => {
    getWardDropdown();
    getRoomMasterDropdown();
    getOpeartionTheatreDropdown();
    getAnaesthesiaDropdown();
    getServiceDropdown();
    getRegionDropdown();
    getDoctorDropdown();
    getEquipmentDropdown()
  }, [
    getWardDropdown,
    getRoomMasterDropdown,
    getOpeartionTheatreDropdown,
    getAnaesthesiaDropdown,
    getServiceDropdown,
    getRegionDropdown,
    getDoctorDropdown,
    getEquipmentDropdown
  ]);

  const handleRowOpdSchedule = (row) => {
    console.log('HELLLO ROW IS HERE', row);
    setValue('ipd_no', row?.ipd_no);
    setValue('patient_name', row?.patient?.name);
    setValue('gender', row?.patient?.gender);
    setValue('age', calculateAge(row?.patient?.dob));
    setValue('mobile', row?.patient?.mobile_no);
    setValue('room', row?.ipdpatient?.consultant_detail?.room);
    setValue('bed_no', row?.ipdpatient?.consultant_detail?.bed_no);
    setValue('ward', row?.roomDetails?.[0]?.ward);
    setValue('optheatre', row?.optheatre);
    setValue('uhid', row?.uhid);
    setSurgeryDetails(row?.surgery_items);
    setResourceDetails(row?.resource_detail);
    setOpenOtScheduleDialog(false);
  };

  useEffect(() => {
    handleFetchOTschedule(input);
  }, [inputOt]);
  
  const handleFetchOTschedule = async () => {
    const lowercasedInput = inputOt.toLowerCase().trim();
    setOtScheduleDataObj({ loading: true });
    const response = await request('/ot-schedule-done-list', { method: 'GET',  query: { name: lowercasedInput ,limit:10} });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOtScheduleDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOtScheduleDataObj({ loading: false });
    }
  };

  const handleOTsChange = (e) => {
    const newInput = e.target.value;
    setInputOt(newInput);
  };


  const handleSurgeryEdit = (row) => {
    setAddSurgeryDialogOpen(true);
    setEditData(row);
    setIsEditMode(true);
  };

  const handleDiagnosEdit = (row) => {
    console.log('HELLLO DIAGNOSIS row', row);
    setAddDiagnosDialogOpen(true);
    setEditData(row);
    setIsEditMode(true);
  };

  const handleResourceEdit = (row) => {
    console.log('HELLLO DIAGNOSIS row', row);
    setAddResourcesDialogOpen(true);
    setEditData(row);
    setIsEditMode(true);
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data);
    console.log({ data });
  };

  useEffect(() => {
    if (otScheduleDataObj.data && otScheduleDataObj.data.length > 0) {
      setOriginalOTScheduleData(otScheduleDataObj.data);
      setIsFiltered(false);
    }
  }, [otScheduleDataObj.data]);

  useEffect(() => {
    handleOt(inputOt);
  }, [inputOt]);

  const handleOt = () => {
    const lowercasedInput = inputOt.toLowerCase();
    const filtered = otScheduleDataObj.data.filter(
      (item) =>
        item.patient?.name.toString().toLowerCase().includes(lowercasedInput) ||
        item.uhid.toString().toLowerCase().includes(lowercasedInput)
    );
    setOriginalOTScheduleData(filtered);
  };

  useEffect(() => {
    if (oTEntryDataObj.data && oTEntryDataObj.data.length > 0) {
      setOriginalData(oTEntryDataObj.data);
      setIsFiltered(false);
    }
  }, [oTEntryDataObj.data]);

  useEffect(() => {
    handleUhidSearch(input);
  }, [input]);

  const handleUhidSearch = () => {
    const lowercasedInput = input.toLowerCase();
    const filtered = oTEntryDataObj.data.filter(
      (item) =>
        item?.uhid?.toString().toLowerCase().includes(lowercasedInput) ||
        item?.patient?.name?.toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };


  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };
  
  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
  
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }
  
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
    
      if (existingRow) {
        const updatedRows = prevSelectedRows.map((selectedRow) =>
          selectedRow._id === row._id
            ? { ...selectedRow, [field]: !existingRow[field] } 
            : selectedRow
        );
    
        return updatedRows.filter((row) => row.ok); 
      } else {
        return [
          ...prevSelectedRows,
          { ...row, [field]: true, ok: field === 'ok' || '' }, 
        ];
      }
    });
  };

  useEffect(() => {
    if (selectedRows && selectedRows.length > 0) {
      const combinedDetails = selectedRows
        .map(row => row.otnotes)  
        .join('\n\n'); 
      setEditorData(combinedDetails); 
    } else {
      setEditorData('');
    }
  }, [selectedRows]); 


  const fetchTemplateMaster = async () => {
    setDischargeSummaryTemplateList({ loading: true });
    const response = await request('/otnotes-list', { method: 'GET'});
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDischargeSummaryTemplateList({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDischargeSummaryTemplateList({ loading: false });
    }
  };

useEffect(()=>{
  fetchTemplateMaster()
},[])


  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                OT Entry
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                    setEditorData('')
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={'Exit'} variant="contained"
                 onClick={()=>setCurrentAction('')}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>OT No./Date</Typography>
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="OT No." name="ot_no" />
                    <TextField type="date" disabled={true} sx={{ flex: 0.4 }} placeholder="" name="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                      IPD No
                    </Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="ipd_no" placeholder="" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                      Ward Name
                    </Typography>
                    <SelectTag
                      disabled
                      formControlSX={{ flex: 0.8 }}
                      menus={wardDropdown.map((data) => ({ ...data, name: data.name }))}
                      name="ward"
                      placeholder="Ward Name"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                      Anaesthesia
                    </Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.8,
                        border: currentAction ? '0.5px solid red' : ''
                      }}
                      name="anaesthesia"
                      placeholder="Anaesthesia"
                      menus={anaesthesiaDropdown.map((data) => ({
                        ...data,
                        name: data.anaesthesia
                      }))}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.31, fontWeight: 600, fontSize: '1.4rem' }}>Sch No./Date</Typography>
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="Search By Schedule" name="sch_no" />
                    <Button
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={() => {
                        setOpenOtScheduleDialog(true);
                      }}
                    >
                      <SearchIcon />
                    </Button>
                    <TextField disabled={true} sx={{ flex: 0.3 }} placeholder="" name="schedule_date" />
                  </Stack>

                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                      Patient Name
                    </Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="patient_name" placeholder="Enter Patient Name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Room/Bed No</Typography>

                    <SelectTag
                      disabled
                      formControlSX={{ flex: 0.4 }}
                      name="room"
                      menus={roomMasterDropdown.map((data) => ({ ...data, name: data.room_no }))}
                      placeholder="Select Room"
                    />
                    <TextField disabled sx={{ flex: 0.4 }} name="bed_no" placeholder="Bed No." />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>UHID No/ OPNo.</Typography>
                    <TextField sx={{ flex: 0.4 }} name="uhid" placeholder="Search By Uhid " disabled />
                    <TextField disabled={true} sx={{ flex: 0.4 }} name="op" placeholder="Op No." />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.34, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                      Gen/Age/Mobile
                    </Typography>
                    <SelectTag
                      disabled
                      formControlSX={{ flex: 0.3 }}
                      name="gender"
                      placeholder="Select Gender"
                      menus={GENDER_DROPDOWN}
                    />
                    <TextField disabled sx={{ flex: 0.3 }} name="age" placeholder="Age" />
                    <TextField disabled={true} sx={{ flex: 0.3 }} name="mobile" placeholder="Mobile No." />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                      OP Theatre
                    </Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="optheatre"
                      placeholder="Select Operation theatre"
                      menus={operationtheatreDropdown.map((data) => ({
                        ...data,
                        name: data.operationtheatre
                      }))}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                      Remarks
                    </Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="remarks"
                      placeholder="Remarks"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ borderBottom: '0px solid', borderColor: 'divider' }}>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(0)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 700,
                        
                      }}
                    >
                      Operation Details
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => handleActiveTab(1)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 700
                      }}
                    >
                      Anaesthesia details
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => handleActiveTab(2)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 700
                      }}
                    >
                      Post Operative Status & Order
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => handleActiveTab(3)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 700
                      }}
                    >
                      OT Notes
                    </Button>
                  </Box>

                  {activeTab === 0 && (
                    <>
                      <Button
                        sx={{ marginTop: '1%' }}
                        variant="contained"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        onClick={() => {
                          setAddSurgeryDialogOpen(true);
                        }}
                      >
                        Add Surgery
                      </Button>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: 'flex', flexDirection: 'column', boxShadow: '0px 2px 2px #0099ff' }}
                      >
                        <Table
                          containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                          columns={ADD_SUREGRY}
                          data={
                            (surgeryDetails && surgeryDetails.map((data) => ({ _id: data.surgery, ...data }))) || []
                          }
                          showEditButton={true}
                          handleDeleteRow={(row) => handleSuregryDelete(row)}
                          disabled={!['new', 'edit'].includes(currentAction)}
                          onClickEditRow={handleSurgeryEdit}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Grid
                          item
                          xs={6}
                          sx={{ display: 'flex', flexDirection: 'column', boxShadow: '0px 2px 2px #0099ff' }}
                        >
                          <Button
                            sx={{
                              marginTop: '1%',
                              width: '140px'
                            }}
                            variant="contained"
                            disabled={!['new', 'edit'].includes(currentAction)}
                            onClick={() => setAddDiagnosDialogOpen(true)}
                          >
                            Add Diagnosis
                          </Button>
                          <Table
                            containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                            data={diagnos.map((data) => ({ _id: data.add_diagnos, ...data })) || []}
                            columns={ADD_DIAGNOSIS}
                            size="small"
                            showEditButton={true}
                            onClickEditRow={(row) => handleDiagnosEdit(row)}
                            handleDeleteRow={(row) => handleRowDelete(row)}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sx={{ display: 'flex', flexDirection: 'column', boxShadow: '0px 2px 2px #0099ff' }}
                        >
                          <Button
                            sx={{ marginTop: '1%', width: '140px', marginLeft: '75%' }}
                            variant="contained"
                            disabled={!['new', 'edit'].includes(currentAction)}
                            onClick={() => {
                              setAddResourcesDialogOpen(true);
                            }}
                          >
                            Add Resource
                          </Button>
                          <Table
                            containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                            data={resourceDetails.map((data) => ({ _id: data.doctor, ...data })) || []}
                            columns={ADD_Resource}
                            size="small"
                            handleDeleteRow={(row) => handleRowResourceDelete(row)}
                            showEditButton={true}
                            onClickEditRow={(row) => handleResourceEdit(row)}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {activeTab === 1 && (
                    <>
                      <Grid
                        item
                        xs={8}
                        sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, justifyContent: 'center' }}
                      >
                        <Stack sx={{ width: '50%' }} direction="column">
                          <Typography sx={{ fontSize: '1.8rem', textDecoration: 'underline', fontWeight: 700 }}>
                            Pre
                          </Typography>
                          <Stack spacing={0.1} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Bp</Typography>
                            <TextField
                              sx={{ flex: 1 }}
                              name="pre_bp"
                              placeholder="BP"
                              disabled={!['new', 'edit'].includes(currentAction)}
                            />
                          </Stack>
                          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Pulse</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="pre_pulse"
                              placeholder="Pulse"
                            />
                          </Stack>
                          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Temp.</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="pre_temprature"
                              placeholder="Temprature"
                            />
                          </Stack>
                          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>R/R</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="pre_r/r"
                              placeholder="R/R"
                            />
                          </Stack>
                          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Spo 2</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="pre_spo2"
                              placeholder="Spo 2"
                            />
                          </Stack>
                        </Stack>
                        <Stack sx={{ width: '50%' }} direction="column" spacing={1}>
                          <Typography
                            sx={{
                              fontSize: '1.8rem',
                              fontStyle: 'underline',
                              fontWeight: 700,
                              textDecoration: 'underline'
                            }}
                          >
                            Post
                          </Typography>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Bp</Typography>
                            <TextField
                              sx={{ flex: 1 }}
                              name="post_bp"
                              placeholder="BP"
                              disabled={!['new', 'edit'].includes(currentAction)}
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Pulse</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="post_pulse"
                              placeholder="Pulse"
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Temp.</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="post_temprature"
                              placeholder="Temprature"
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>R/R</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="post_r/r"
                              placeholder="R/R"
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Spo 2</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 1 }}
                              name="post_spo2"
                              placeholder="Spo 2"
                            />
                          </Stack>
                        </Stack>
                      </Grid>
                      <Stack
                        sx={{
                          mb: 0.3,
                          marginTop: '1%',
                          width: '50%',
                          display: 'flex',
                          justifyContent: 'center'
                        }}
                        direction="column"
                        spacing={1}
                      >
                        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Any Others</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="any_other"
                          multiline
                          rows={5}
                          placeholder="Any Other"
                        />
                      </Stack>
                    </>
                  )}
                  {activeTab === 2 && (
                    <>
                      <Grid
                        item
                        xs={8}
                        sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, justifyContent: 'center' }}
                      >
                        <Stack sx={{ mb: 0.3, marginTop: '1%', width: '100%' }} direction="column" spacing={1}>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>
                              General Condition
                            </Typography>
                            <TextField
                              sx={{ flex: 0.8 }}
                              name="general_condition"
                              placeholder=""
                              disabled={!['new', 'edit'].includes(currentAction)}
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Bp</Typography>
                            <TextField
                              sx={{ flex: 0.8 }}
                              name="post_operative_bp"
                              placeholder="BP"
                              disabled={!['new', 'edit'].includes(currentAction)}
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Pulse</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 0.8 }}
                              name="post_operative_pulse"
                              placeholder=""
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Temprature</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 0.8 }}
                              name="post_operative_temprature"
                              placeholder=""
                            />
                          </Stack>
                        </Stack>
                        <Stack sx={{ mb: 0.2, marginTop: '1%', width: '100%' }} direction="column" spacing={1}>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Spo 2</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 0.8 }}
                              name="post_operative_spo2"
                              placeholder=""
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>R/R</Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 0.8 }}
                              name="post_operative_r/r"
                              placeholder=""
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>
                              Urine OutPut
                            </Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 0.8 }}
                              name="post_operative_urine_output"
                              placeholder=""
                            />
                          </Stack>
                          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>
                              Artificial Ventilation
                            </Typography>
                            <TextField
                              disabled={!['new', 'edit'].includes(currentAction)}
                              sx={{ flex: 0.8 }}
                              name="post_operative_artificial_ventilation"
                              placeholder="Temprature"
                            />
                          </Stack>
                        </Stack>
                      </Grid>
                      <Stack
                        sx={{ mb: 0.3, marginTop: '1%', width: '60%', justifyContent: '' }}
                        direction="column"
                        spacing={1}
                      >
                        <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>
                          Post Operative orders
                        </Typography>

                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 1 }}
                          name="post_operative_orders"
                          placeholder=""
                          rows={5}
                          multiline
                        />
                      </Stack>
                    </>
                  )}
                  {activeTab === 3 && (
                    <>
                      <Stack spacing={6} sx={{ marginTop: '2%' }}>
                      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                <Table
                                                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                  data={dischargeSummaryTemplateList?.data || []}
                                                  columns={OT_TEMPLATE_TABLE_HEADER}
                                                  size="small"
                                                  showOk={true}
                                                  isSelected={isSelected}
                                                  handleRowSelect={handleRowSelect}
                                                />
                                              </Grid>
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Typography sx={{ flex: 0.3, fontSize: '1.6rem', fontWeight: 700 }}>Ot Notes</Typography>
                          <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <CKEditor
                              editor={ClassicEditor}
                              data={editorData}
                              onReady={(editor) => {
                                console.log('Editor is ready to use!', editor);
                              }}
                              onChange={handleEditorChange}
                              onBlur={(event, editor) => {
                                console.log('Blur.', editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log('Focus.', editor);
                              }}
                            />
                          </Grid>
                        </Stack>
                      </Stack>
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            OT Entry Query Window
          </Typography>

          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{ 
               width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' 
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLable-root': {
                fontSize: '1.2rem' 
              }
             }}
            label="Search Patient By Name"
            variant="outlined"
            value={input}
            onChange={handleOtChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={oTEntryDataObj?.data || []}
          loading={oTEntryDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={openOtScheduleDialog}
        onClose={() => setOpenOtScheduleDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            OT Patient Schedules
          </Typography>

          <IconButton onClick={() => setOpenOtScheduleDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
                width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' 
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={inputOt}
            onChange={handleOTsChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={OT_SCHEDULE_TABLE_HEADER}
          data={otScheduleDataObj?.data || []}
          loading={otScheduleDataObj.loading}
          onRowClick={(row) => {
            handleRowOpdSchedule(row);
          }}
        />
      </Dialog>
      <Dialog
        open={addDiagnosDialogOpen}
        onClose={() => setAddDiagnosDialogOpen(false)}
        PaperProps={{ sx: { p: 2, width: '35rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <DischargeSummaryAddDiagnosForm
          onClose={() => setAddDiagnosDialogOpen(false)}
          onAdd={(row) => {
            if (isEditMode && editData) {
              // Edit Mode: Update the existing row with the same `add_diagnos`
              setDiagnos((prev) =>
                prev.map((diagnos) =>
                  diagnos.add_diagnos === editData.add_diagnos
                    ? { ...diagnos, ...row } // Merge the updated data
                    : diagnos
                )
              );
            } else {
              // Add Mode: Check for duplicates and add a new row
              if (diagnos.some((diagnos) => diagnos.add_diagnos === row.add_diagnos)) {
                toast('Diagnos already taken', { variant: 'error' });
              } else {
                setDiagnos((prev) => [...prev, row]);
              }
            }
          }}
          editData={editData}
          isEditMode={isEditMode}
        />
        ;
      </Dialog>
      <Dialog
        open={addSurgeryDialogOpen}
        onClose={() => setAddSurgeryDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '57vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <AddSurgeryDetailsForm
          doctorID={doctorIDRef.current}
          onClose={() => setAddSurgeryDialogOpen(false)}
          onAdd={onDetailAddHandler}
          serviceDropdown={serviceDropdown}
          regionDropdown={regionDropdown}
          editData={editData}
          isEditMode={isEditMode}
        />
      </Dialog>
      <Dialog
        open={addResourcesDialogOpen}
        onClose={() => setAddResourcesDialogOpen(false)}
        PaperProps={{ sx: { width: '70%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <AddResourcesDetailsForm
          doctorID={doctorIDRef.current}
          onClose={() => setAddResourcesDialogOpen(false)}
          onAdd={onAddAddResourcehandler}
          doctorDropdown={doctorDropdown}
          editData={editData}
          isEditMode={isEditMode}
          equipmentDropdown={equipmentDropdown}
        />
      </Dialog>
    </>
  );
};
